import DashboardDemographicsImage from "./DashboardDemographicsImage";

export default DashboardDemographicsImage;